// Client display-name helpers, shared across the client list, dashboard, and
// detail header so initials + hover tooltip behave identically everywhere.

// "Taquilla Bennett" -> "TB". Single-word names take their first two letters.
export function clientInitials(name?: string | null): string {
  const parts = (name ?? "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

// "Taquilla Bennett" -> "Taquilla B." (first name + last initial). Used where a
// denser label is wanted than the full legal name.
export function shortName(name?: string | null): string {
  const parts = (name ?? "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "(unnamed)";
  if (parts.length === 1) return parts[0];
  return `${parts[0]} ${parts[parts.length - 1][0]}.`;
}
